import { styled } from 'styled-components'

import { Typography } from '@b-stock/fe-core/design-system'

import { controlColors } from '../ui'

/**
 * Auto-width wrapper for <select>. A hidden ::after pseudo-element renders the
 * currently displayed text in an overlapping grid cell, sizing the container to
 * fit. The select is collapsed to width:0 and stretched to min-width:100% so it
 * adopts the pseudo-element's width rather than its own intrinsic (widest
 * option) width.
 */
const Body = styled.div`
  display: inline-grid;

  & > select {
    grid-area: 1 / 1;
    min-width: 100%;
    width: 0;
  }

  &::after {
    ${Typography.Subtitle2}
    content: attr(data-value);
    grid-area: 1 / 1;
    padding: 0 calc(1.75rem + 0.125rem) 0 calc(0.6875rem + 0.125rem);
    visibility: hidden;
    white-space: nowrap;
  }
`

/**
 * The inline SVG is a chevron to replace the (unstyleable) native arrow
 * so we can control its position.
 * As of 2026-05, CSS selector ::picker-icon is not yet well-supported.
 */
const Select = styled.select`
  ${Typography.Subtitle2}
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 8'%3E%3Cpath d='M1.4 0L6 4.6 10.6 0 12 1.4l-6 6-6-6z' fill='%23555'/%3E%3C/svg%3E");
  background-position: right 0.6875rem center;
  background-repeat: no-repeat;
  background-size: 0.625rem;
  border: 0.0625rem solid;
  border-radius: 0.25rem;
  cursor: pointer;
  height: 2.5rem;
  padding: 0 1.75rem 0 0.6875rem;

  // controlColors must come after border shorthand prop (it has border-color)
  ${controlColors}
`

export const ControlSelect = ({
  children,
  displayValue,
  ...props
}: React.ComponentProps<typeof Select> & { displayValue: string }) => (
  <Body data-value={displayValue}>
    <Select {...props}>{children}</Select>
  </Body>
)
